import BackendService from './BackendService';

export default class WebsitesService {
  static getWebsites() {
    return BackendService.get('/websites');
  }

  static getWebsiteByDealerId(dealerId) {
    return BackendService.get(`/websites/dealer/${dealerId}`);
  }

  static getWebsitesLight() {
    return BackendService.get('/websites/light');
  }

  static getWebsite(websiteId) {
    return BackendService.get(`/websites/${websiteId}`);
  }

  static createWebsite(website) {
    return BackendService.post('/websites', {
      body: website,
    });
  }

  static updateWebsite(website) {
    return BackendService.put(`/websites/${website.id}`, {
      body: website,
    });
  }

  static setWebsiteTheme(website, target) {
    return BackendService.put(`/websites/${website.id}/theme`, {
      body: {
        theme: website.theme,
        target,
      },
    });
  }

  static deleteWebsite(websiteId) {
    return BackendService.delete(`/websites/${websiteId}`);
  }

  static getAvailableThemes(client) {
    return BackendService.get(
      `/websites/themes/all${client ? `?client=${client}` : ''}`,
    );
  }
}
